import { restaurantsUrl } from './resources.js'
import common from './common.js'
import store from '../store/index.js'

async function getRestaurantsByRestaurantOwner() {
    let restaurantownerid = store.state.login.restaurantOwnerId;
    let url = `${restaurantsUrl}/getbyrestaurantowner/${restaurantownerid}`;
    let data;
    await common.getDataWithToken(url)
                .then(response => {
                    data = response.restaurants });
    return data;
}

async function getRestaurantById(restaurantid) {
    let url = `${restaurantsUrl}/${restaurantid}`;
    await common.getDataWithToken(url)
                .then((response) => {
        return response;
    });
}

async function updateRestaurant(data) {
    console.log(data);
    let url = `${restaurantsUrl}/${data.restaurantId}`;
    await common.putData(url, data)
                .then( (response) => { console.log(response); return response; } );
}

export default {
    name: 'restaurantsService',
    getRestaurantsByRestaurantOwner,
    getRestaurantById,
    updateRestaurant
}